import React from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {
    TextField,
    FormControl,
    FormLabel,
    FormHelperText,
} from '@material-ui/core';
import get from 'lodash.get';
import {toSnakeCase} from '../locale/utils';
import {Show} from 'components/utils';

const Text = ({
    label,
    name,
    placeholder,
    multiline,
    required,
    inputProps,
    InputProps,
    hidden,
    transform,
    variant,
    disabled,
    autoFocus,
    margin,
    autocomplete,
    size,
    value,
    ...props
}) => {
    const {control, errors, register} = useFormContext();
    const error = get(errors, name);

    return hidden ? (
        <FormControl error={!!error} style={{display: 'block', ...props.style}}>
            <input
                id={name}
                data-cy={`form-field-${toSnakeCase(name)}`}
                name={name}
                ref={register}
                key='field'
                {...inputProps}
                {...props}
                type='hidden'
            />
            <FormHelperText>{error?.message}</FormHelperText>
        </FormControl>
    ) : (
        <FormControl fullWidth error={!!error}>
            <Show condition={label}>
                <FormLabel required={required}>{label}</FormLabel>
            </Show>
            <Controller
                render={p => (
                    <TextField
                        {...p}
                        {...props}
                        id={name}
                        fullWidth
                        error={!!errors[name]}
                        placeholder={placeholder}
                        variant={variant}
                        multiline={multiline}
                        disabled={disabled}
                        autoFocus={autoFocus}
                        margin={margin}
                        size={size}
                        inputProps={{
                            'data-cy': `form-field-${toSnakeCase(name)}`,
                            ...inputProps,
                            autocomplete,
                        }}
                        InputProps={InputProps}
                        onChange={e => {
                            const data = transform
                                ? transform(
                                      e.value ||
                                          e.target?.value ||
                                          e.originalTarget?.value
                                  )
                                : e;
                            p.onChange(data);
                            props.onChange &&
                                typeof props.onChange === 'function' &&
                                props.onChange(data);
                        }}
                    />
                )}
                name={name}
                control={control}
            />
            <FormHelperText>{error?.message}</FormHelperText>
        </FormControl>
    );
};

export default Text;
